module.exports = __webpack_public_path__ + "static/media/kkk-back.c706357a.svg";